export default __webpack_public_path__ + "static/media/quoraLogo.566f5776.png";